export default "__VITE_ASSET__8Ze419uY__"